import { VirtualScroller as VirtualScrollers } from 'primereact/virtualscroller';  

const VirtualScroller = ({...rest}) => {

    return (
        <VirtualScrollers {...rest} />
    )

};

export default VirtualScroller;